<template>
  <div class="f-col ctr forgotten">
    <div class="f-col forgotten-title">
      <span>Recuperar sua senha</span>
    </div>
    <form class="f-col ctr" @submit.prevent="handleSubmit">
      <div class="f-row ctr form-field">
        <label class="f-row ctr" for="email-field">
          <Icon icon="user" />
          <span class="hidden">Email</span>
        </label>
        <input
          class="f-row ctr"
          id="email-field"
          type="email"
          name="email"
          placeholder="Email"
          required
          v-model="email"
        />
      </div>
      <div class="f-row ctr form-submit">
        <button class="button-submit" type="submit" :disabled="loading">
          <template v-if="loading">
            <Icon
              icon="spinner"
              spin
              style="font-size: 22px; animation-duration: 1.2s"
            />
          </template>
          <template v-else>Enviar email de recuperação</template>
        </button>
      </div>
    </form>
    <div class="f-row ctr">
      <button class="back-to-login" @click="backToLogin">
        Voltar para o login
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Forgotten",
  data() {
    return {
      loading: false,
      email: "",
      errorMessage: "",
    };
  },
  methods: {
    backToLogin() {
      this.$store.commit("PRELUDE_UPDATE_CONTEXT", "login");
    },
    async handleSubmit() {
      try {
        if (this.loading) return;
        this.loading = true;
        const { email } = this;

        if (email) {
          const { data } = await axios({
            url: `${process.env.VUE_APP_ADMIN_API_URL}/users.recoveryPassword`,
            method: "POST",
            data: { email },
          });
          this.$store.dispatch("ALERT", data.message);
        }
        this.backToLogin();
        this.loading = false;
      } catch (err) {
        this.errorMessage = !(err.name === "TypeError")
          ? err.message
          : "Não foi possível realizar esta operação";
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.forgotten {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.forgotten-title {
  font-size: 14px;
  min-height: 22px;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
  color: #fff;
}

.form-field {
  margin: 6px;
}

.form-field > input {
  width: 180px;
  height: 54px;
  padding: 0 16px;
  font-size: 14px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #f2f2f6;
}

.form-field > label {
  height: 54px;
  width: 56px;
  font-size: 14px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  background-color: #7e8e9edf;
}

.form-submit {
  margin: 6px;
}

.button-submit {
  width: 268px;
  height: 54px;
  font-weight: 700;
  text-transform: uppercase;
  color: #eee;
  background-color: #25aae1;
  border-radius: 0.25rem;
}

.back-to-login {
  margin: 6px;
  font-size: 14px;
  color: #f1f1f1;
}
</style>
